import { render, staticRenderFns } from "./CommonView.vue?vue&type=template&id=5a0e222e&"
import script from "./CommonView.vue?vue&type=script&lang=js&"
export * from "./CommonView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports